import { INITIAL_EBIS_INTERFACE_MONITORING_COL_DEF_CCGLIN, transferRowDataForCCGLIN } from "presentation/constant/EbisInterfaceMonitoring/detail/EbisDetailColumnDefinitionMessageTypeForCCGLIN";
import { INITIAL_EBIS_INTERFACE_MONITORING_COL_DEF_SLARDS, transferRowDataForSLARDS } from "presentation/constant/EbisInterfaceMonitoring/detail/EbisDetailColumnDefinitionMessageTypeForSLARDS";
import { INITIAL_EBIS_INTERFACE_MONITORING_COL_DEF_SLARLN, transferRowDataForSLARLN } from "presentation/constant/EbisInterfaceMonitoring/detail/EbisDetailColumnDefinitionMessageTypeForSLARLN";
import { INITIAL_EBIS_INTERFACE_MONITORING_COL_DEF_SLARRE, transferRowDataForSLARRE } from "presentation/constant/EbisInterfaceMonitoring/detail/EbisDetailColumnDefinitionMessageTypeForSLARRE";
import { EbisInterfaceMonitoringMaintenanceConstant } from "presentation/constant/EbisInterfaceMonitoring/EbisInterfaceMonitoringMaintenanceConstant";
import { useEbisInterfaceMonitoringMaintenanceVM } from "presentation/hook/EbisInterfaceMonitoring/useEbisInterfaceMonitoringMaintenanceVM";
import { useEbisInterfaceMonitoringMaintenanceTracked } from "presentation/store/EbisInterfaceMonitoring/EbisInterfaceMonitoringMaintenanceProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useMemo, useRef } from "react";
import { HPHBreadcrumb, IconButton } from "veronica-ui-component/dist/component/core";
import { Breadcrumb, Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";
import { EbisInterfaceMonitoringHeaderPanel } from "./EbisInterfaceMonitoringHeaderPanel";


const EbisInterfaceMonitoringDetailTablePanel: React.FC = () => {
    const [ebisInterfaceMonitoringState] = useEbisInterfaceMonitoringMaintenanceTracked();
    const ebisInterfaceMonitoringMainVM = useEbisInterfaceMonitoringMaintenanceVM();
    const { currentSelectedRow, ebisInterfacemonitoringDtlList } = ebisInterfaceMonitoringState;
    let gridRef: any = useRef(null);


    const handClose = useCallback(() => {
        ebisInterfaceMonitoringMainVM.onCancel();
    }, [ebisInterfaceMonitoringMainVM]);



    const memoEbisInterfaceMonitoringDtlTable = useMemo(() => {
        return (
            <NbisTable
                id='interface-monitoring-dtl-table'
                isNewColumnSetting={true}
                columns={(currentSelectedRow.messageType === "CCGLIN" ? INITIAL_EBIS_INTERFACE_MONITORING_COL_DEF_CCGLIN :
                    (currentSelectedRow.messageType === "SLARDS" ? INITIAL_EBIS_INTERFACE_MONITORING_COL_DEF_SLARDS :
                        (currentSelectedRow.messageType === "SLARLN" ? INITIAL_EBIS_INTERFACE_MONITORING_COL_DEF_SLARLN :
                            INITIAL_EBIS_INTERFACE_MONITORING_COL_DEF_SLARRE)))}
                data={(currentSelectedRow.messageType === "CCGLIN" ? transferRowDataForCCGLIN(ebisInterfacemonitoringDtlList ?? []) :
                    currentSelectedRow.messageType === "SLARDS" ? transferRowDataForSLARDS(ebisInterfacemonitoringDtlList ?? []) :
                        currentSelectedRow.messageType === "SLARLN" ? transferRowDataForSLARLN(ebisInterfacemonitoringDtlList ?? []) :
                            transferRowDataForSLARRE(ebisInterfacemonitoringDtlList ?? []))}
                showPaginator={false}
                editable={false}
                showSearchIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                rowSelection={"single"}
                isRowHighligted={true}
                gridHeight="customHeight"
                customHeight="calc(100vh - 165px)"
                ref={gridRef}
            />
        );
    }, [currentSelectedRow.messageType, ebisInterfacemonitoringDtlList])

    return <><div className="main-comp-wrapper">
        <Sidebarheader style={{ width: '100%' }}>
            <Breadcrumb>
                <HPHBreadcrumb breadcrumbData={[{ title: EbisInterfaceMonitoringMaintenanceConstant.CATEGORY },
                { title: EbisInterfaceMonitoringMaintenanceConstant.TITLE }]} onCurrentClick={() => { }}>
                </HPHBreadcrumb>
            </Breadcrumb>
            <StyledAction>
                <>
                    <IconButton
                        fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={handClose} />
                </>
            </StyledAction>
        </Sidebarheader>
        <EbisInterfaceMonitoringHeaderPanel />
        <TableWrapper>
            {memoEbisInterfaceMonitoringDtlTable}
        </TableWrapper>
    </div></>;
}

export default memo(EbisInterfaceMonitoringDetailTablePanel);
